import * as yup from 'yup'

const revokeReportSchema = yup.object().shape({
  reason: yup
    .object()
    .shape({
      label: yup.string().required(),
      value: yup.string().required(),
    })
    .nullable()
    .required('Reason for revocation is required'),
  evidence: yup.array().nullable(),
  notes: yup.string().required('Additional notes are required'),
  effectiveDate: yup
    .object()
    .shape({
      label: yup.string().required(),
      value: yup
        .string()
        .oneOf(
          ['immediately', 'on_next_cycle', 'custom_date'],
          'Selected option is not available yet'
        )
        .required(),
    })
    .nullable()
    .required('Revocation effective date is required'),
  // Only required when "Custom date" is selected. The MyCalendar picker bounds
  // the range (tomorrow → consent expiry), so here we just enforce presence.
  customDate: yup
    .date()
    .nullable()
    .when('effectiveDate', {
      is: (opt) => opt?.value === 'custom_date',
      then: (s) => s.typeError('Please pick a date').required('Please pick a date'),
      otherwise: (s) => s.nullable().optional(),
    }),
  consent: yup
    .boolean()
    .oneOf([true], 'You must agree to revoke this monitoring')
    .required(),
})

export default revokeReportSchema
